import { StepConnector, stepConnectorClasses, styled } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Theme } from '@mui/material/styles';

export const ArrowStepConnector = styled(StepConnector)(({ theme }) => ({
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#e0e0e0',
    position: 'relative',
    borderRadius: 2,
    '&::after': {
      content: '""',
      position: 'absolute',
      right: '-4px',
      top: '50%',
      transform: 'translateY(-50%)',
      width: '28px',
      height: '28px',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      backgroundImage: `url("data:image/svg+xml;utf8,${encodeURIComponent(`
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' stroke-width='2.5' stroke='${theme.palette.grey[300]}' fill='none' stroke-linecap='round' stroke-linejoin='round'>
          <polyline points='12 5 19 12 12 19'/>
        </svg>
      `)}")`,
    },
  },
}));

export const useStyles = makeStyles((theme: Theme) => ({
  closeBtn: {
    color: "#fff !important",
    backgroundColor: "#FF4842 !important",
    "&:hover": {
      backgroundColor: "#FF4842 !important",
    },
  },
  nextBtn: {
    color: "#fff !important",
    backgroundColor: "#00AB55 !important",
    "&:hover": {
      backgroundColor: "#00AB55 !important",
    },
  },
  yesBtn: {
    color: "#fff",
    backgroundColor: "#00AB55",
    "&:hover": {
      backgroundColor: "#00AB55",
    },
  },
  noBtn: {
    color: "#fff !important",
    backgroundColor: "#FF4842 !important",
    "&:hover": {
      backgroundColor: "#FF4842 !important",
    },
  },
  addMargin: {
    margin: 10
  },
  tableContainer: {
    backgroundColor: '#FFF',
    width: '100%',
    paddingTop: '70px',
    paddingBottom: '38px',
    paddingLeft: '40px',
    paddingRight: '40px',
    borderRadius: '16px',
    marginTop: '40px',
    minHeight: '25vh',
    boxShadow: (props: any) =>
      `0px 16px 32px -4px ${props?.boxShadowColor ? props?.boxShadowColor : 'rgba(145,158,171,0.24)'
      }, 0px 0px 2px rgba(145,158,171,0.24)`,
    '& .MuiDataGrid-columnHeaderWrapper': {
      backgroundColor: '#f4f6f8',
      borderRadius: '8px',
    },
    '& .MuiTablePagination-select': {
      height: '30px',
    },
    '& .MuiDataGrid-toolbarContainer': {
      margin: '20px 10px 20px 20px',
    },
    '& .MuiDataGrid-footerContainer': {
      minHeight: '160px',
    },
    '& .MuiDataGrid-root': {
      border: 'none',
    },
  },
  searchContainer: {
    flex: '1 auto',
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      height: '56px',
    },
  },
  dataGrid: {
    width: '100%',
    padding: 8,
  },
  headerOpts: {
    marginLeft: '25px',
    marginTop: '25px',
  },
  customLabelStyle: {
    fontSize: '13px !important',
    fontWeight: '700 !important',
    color: '#212B36 !important',
  },
  active: {
    fontSize: '13px !important',
    fontWeight: '700 !important',
    color: '#131313 !important',
  },
  completed: {
    fontSize: '13px !important',
    color: '#00AB55 !important',
  },
  shapeBox: {
    top: "-44px",
    width: "160px",
    zIndex: "-1",
    height: "160px",
    right: "-104px",
    opacity: "0.12",
    borderRadius: `calc(3 * ${theme.shape.borderRadius}px)`,
    position: "absolute",
    transform: "rotate(50deg)"
  },
  iconShapeBox: {
    position: 'absolute', 
    right: '20px',
    top: '16px',
    width: '30px',
    height: '30px'
  },
  stepCard: {
    width: '100%',
    maxWidth: 220,
    minWidth: 160,
    flex: 1,
    cursor: 'pointer',
    overflow: 'visible',
    boxShadow: 'none',
  }
}));

export const styleTab = [
  { 
    '&.MuiTab-root': {
      '&:first-of-type': {
        marginRight: 0,
      },
      '&:last-of-type': {
        marginRight: 0,
      },
      '&:not(:last-of-type)': {
        marginRight: 0,
      },
      '&:not(:first-of-type)': {
        marginRight: 0,
      },
      '&.Mui-selected': {
        backgroundColor: '#919eab14',
        '&:hover': {
          backgroundColor: '#919eab14'
        },
        '& .MuiTab-iconWrapper': {
          backgroundColor: '#00AB55',
          color: 'white',
          borderRadius: 2
        },
        color: 'black'
      },
      textTransform: 'none',
      borderRadius: 1,
      px: 2,
      py: 0.7,
      my: 1,
      minHeight: 'unset',
      minWidth: 'unset',
      justifyContent: 'start',
      backgroundColor: 'white',
      color: '#919eab'
    }
  }
];

export const styleTabBlack = [
  {
    '&.MuiTab-root': {
      border: '1px solid #919eab52',
      '&.Mui-selected': {
        backgroundColor: 'white',
        borderColor: '#212B36',
        '&:hover': { 
          borderColor: '#212B36', 
          backgroundColor: 'white' 
        },
      },
    },
  },
];

export const cardDialogStyle = [
  {
    border: '1px solid #161c2452',
    borderRadius: '16px',
    height: '100%',
    '&[data-active]': {
      border: '2px solid #161c24',
      '&.MuiCardActionArea-root': {
        '& .focus-icon': {
          opacity: 1,
        },
      },
    },
    '&.MuiCardActionArea-root': {
      '& .focus-icon': {
        opacity: 0,
      },
      '&:hover': {
        border: '2px solid #161c24',
        '& .focus-icon': {
          opacity: 1,
        },
      },
      '& .MuiCardActionArea-focusHighlight': {
        opacity: 0,
        '& .focus-icon': {
          opacity: 1,
        },
      }
    },
  }
];

export const styleTabAll = [...styleTab, ...styleTabBlack];